<div markdown [data]="interpolatedText" class="standardText m mb-4"></div>

